import { TextField } from "@mui/material";
import { PublicKey } from "@solana/web3.js";

import React, { useEffect, useState, FC } from "react";
import { NodeInfoProps } from "../../interfaces";
import { DARK_3, LIGHT_1 } from "../colors";
import TokenAccountChooser from "../tokens/TokenAccountChooser";

const TransferNodeInfo = (props: NodeInfoProps) => {
  const [err, setError] = useState(false);
  const [val, setVal] = useState<null | string>(null);
  useEffect(() => {
    if (props.input?.recipientWallet) {
      setVal(props.input.recipientWallet);
    }
  }, [props.input]);

  return (
    <>
      Recipient Address:{" "}
      <TextField
        error={err}
        style={{ backgroundColor: DARK_3 }}
        InputProps={{ style: { color: LIGHT_1 } }}
        label={err ? "Please enter a valid wallet address" : ""}
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={(e) => {
          try {
            new PublicKey(e.target.value);
            props.updateInput({
              recipientWallet: e.target.value,
            });
            setError(false);
          } catch {
            setError(true);
          }
        }}
      />
    </>
  );
};

export default TransferNodeInfo;
